import script from "./choseService.vue?vue&type=script&setup=true&lang=js"
export * from "./choseService.vue?vue&type=script&setup=true&lang=js"

import "./choseService.vue?vue&type=style&index=0&id=8c681706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c681706"]])

export default __exports__